import { Courses } from "../courses"

export const SupportLearnings = ({pageSwap, courseToUpdate, setCourseToUpdate, AiStarted }) => {
    return(
        <Courses
            titleScreen = "Support learnings"
            CustomerStage = {3}
            pageSwap={pageSwap}
            courseToUpdate={courseToUpdate}
            setCourseToUpdate={setCourseToUpdate}
            AiStarted={AiStarted}
            
        />
    )
}